import jQuery from "jquery";

import { isFormat } from "./format.js";
import { rebuildFunction } from "./vitamin_toggles.js";

const $ = jQuery;

// Adjust line heights on new linear label since calorie font is HUGE
let newLinearAdjustTimeout = null;
export function adjustNewLinearLineHeightForCalorieFont() {
  if (newLinearAdjustTimeout) {
    clearTimeout(newLinearAdjustTimeout);
  }

  /* Wait for the next reflow:  */
  newLinearAdjustTimeout = setTimeout(() => {
    // find line that calories is on
    // adjust that line's height by adding linearextraheight class
    const calories_top = $("#newlinearcalories").position()["top"];
    $(
      "#newlinearnutritionfactstable .linearnutrientcontent, #newlinearnutritionfactstable .linearnutrient, #newlinearnutritionfactstable .linearnutritionheading"
    ).each(function () {
      if ($(this).position()["top"] == calories_top) {
        $(this).addClass("linearextrapadding");
      } else {
        $(this).removeClass("linearextrapadding");
      }
    });
    newLinearAdjustTimeout = null;
  }, 0);
}

//Move tabular nutrients around if they aren't evenly distributed between the 2 cols
export function tabularShuffle() {
  if (
    $(
      "#simplifiedformattoggle, #newsimplifiedformattoggle, #newaggregatesimplifiedformattoggle"
    ).is(":checked")
  ) {
    /* nothing */
  } else {
    $("#filler_col_2, #new_filler_col_2").hide();
    const leftlength = $(".nutrients_col_1:visible").children(":visible").length;
    const rightlength = $(".nutrients_col_2:visible").children(":visible").length;
    if (leftlength - rightlength == 0) {
      $(".nutrients_col_1:visible")
        .children(":visible")
        .last()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .hide();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .next()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
    } else if (leftlength - rightlength == 1) {
      $("#filler_col_2").show();

      if (isFormat("fda/adult/tabular")) {
        $("#new_filler_col_2").show();
      }

      $(".nutrients_col_1:visible")
        .children(":visible")
        .last()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .hide();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .next()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
    }
    // move something over from left to right and call shuffle again
    else if (leftlength - rightlength > 1) {
      const item_to_move = $(".nutrients_col_1:visible").children().last();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
      $(".nutrients_col_2:visible").prepend(item_to_move);
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .hide();
      tabularShuffle();
    }
    // move something over from right to left and call shuffle again
    else if (leftlength - rightlength < 0) {
      const item_to_move = $(".nutrients_col_2:visible").children().first();
      $(".nutrients_col_1:visible").append(item_to_move);
      $(".nutrients_col_1:visible")
        .children(":visible")
        .last()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
      $(".nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .hide();
      tabularShuffle();
    }
  }
}

//Move tabular nutrients into one column on the left for simplified format
export function tabularShuffleLeft() {
  const rightlength = $(".nutrients_col_2:visible").children().length;
  if (rightlength > 0) {
    const item_to_move = $(".nutrients_col_2:visible").children().first();
    $(".nutrients_col_1:visible").append(item_to_move);
    $(".nutrients_col_1:visible")
      .children()
      .last()
      .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
      .show();
    tabularShuffleLeft();
  } else {
    $("#new_filler_col_2, #filler_col_2").hide();
    // hide last nutrient column
    $(".tabular_nutrient_col:last, .new_tabular_nutrient_col:last").hide();
    $("#new_tabular_dual_nutrient_cols").children(".new_tabular_dual_nutrient_col:last").hide();
    // set width based on just 1 column
    $("#tabular_nutrient_cols").css("width", $("#tabularslider").slider("value"));
    $("#new_tabular_nutrient_cols").css("width", $("#newtabularslider").slider("value"));
    rebuildFunction();
  }
}

//Move tabular vitamins around after building them all if they aren't evenly distributed between the 2 cols
export function tabularVitaminShuffle() {
  if ($("#newsimplifiedformattoggle").is(":checked")) {
    $("#new_vitamin_filler_col_2").hide();
  } else {
    const leftlength = $(".vitamin_nutrients_col_1:visible").children(":visible").length;
    const rightlength = $(".vitamin_nutrients_col_2:visible").children(":visible").length;
    if (leftlength - rightlength == 0) {
      /* nothing */
    } else if (leftlength - rightlength == 1) {
      $("#new_vitamin_filler_col_2").hide();
      $(".vitamin_nutrients_col_1:visible")
        .children(":visible")
        .last()
        .find(".hairlineseparator")
        .show();
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator")
        .hide();
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .next()
        .find(".hairlineseparator")
        .show();
      tabularVitaminShuffle();
    }
    // move something over from left to right and call shuffle again
    else if (leftlength - rightlength > 1) {
      const item_to_move = $(".vitamin_nutrients_col_1:visible").children(":visible").last();
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator")
        .show();
      $(".vitamin_nutrients_col_2:visible").prepend(item_to_move);
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator")
        .addClass("separator")
        .removeClass("hairlineseparator");
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .next()
        .find(".separator")
        .addClass("hairlineseparator")
        .removeClass("separator");
      tabularVitaminShuffle();
    }
    // move something over from right to left and call shuffle again
    else if (leftlength - rightlength < 0) {
      const item_to_move = $(".vitamin_nutrients_col_2:visible").children(":visible").first();
      $(".vitamin_nutrients_col_1:visible").append(item_to_move);
      $(".vitamin_nutrients_col_1:visible")
        .children(":visible")
        .last()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .show();
      $(".vitamin_nutrients_col_2:visible")
        .children(":visible")
        .first()
        .find(".hairlineseparator, .subhairlineseparator, .subsubhairlineseparator")
        .hide();
      tabularVitaminShuffle();
    }
  }
}

// for Canada new labels to align if only english or french
export function adjustDailyValueHeight() {
  const daily_value_div = $(".calories-section-new-canada").find(
    ".bilingual-english:visible, .bilingual-french:visible"
  );
  if (daily_value_div.length == 1) {
    if (daily_value_div.height() < 15) {
      // align to bottom rather than top
      daily_value_div.css("padding-top", "10px");
    } else {
      daily_value_div.css("padding-top", "0px");
    }
  } else {
    daily_value_div.css("padding-top", "0px");
  }
}

export function showFootnoteSeparator() {
  if (!(isFormat("fda/adult/vertical") || isFormat("fda/adult/vertical/as_prepared"))) {
    return;
  }

  document.querySelectorAll(".label-footnote-section").forEach((el) => {
    const hasText = $(el).children(":visible").text().trim() !== "";

    if (hasText) {
      $(el).find(".footnote-separator").show();
    } else {
      $(el).find(".footnote-separator").hide();
    }
  });
}
